export enum articlesImagesTypes {
  FETCH_ARTICLES_IMAGES_REQUEST = "FETCH_ARTICLES_IMAGES_REQUEST",
  FETCH_ARTICLES_IMAGES_SUCCESS = "FETCH_ARTICLES_IMAGES_SUCCESS",
  FETCH_ARTICLES_IMAGES_FAILURE = "FETCH_ARTICLES_IMAGES_FAILURE",
}